import React from 'react';
import Balloon from '../../assets/images/balloon.png';
import safeSmart1 from '../../assets/images/safe-smart-1.png';
import safeSmart2 from '../../assets/images/safe_smart_2.png';
import safeSmart3 from '../../assets/images/safe_smart_3.png';

const OurPromise = () => {
  return ( 
    <div className="ourPromise">
      <div className="img mt-5">
        <div className="media">
          <img src={Balloon} alt="Balloon" className="" />
          <div className="media-body">
            <p className="font-weight-bold fs-14 mt-5 font-weight-extrabold text-black">OUR PROMISE</p>
          </div>
        </div>
      </div>      
      <p className="text-primary fs-74 font-weight-light safe-smart-heading">Safe, smart and secure</p>
      <div className="row smart-safe-text">
        <div className="col-md-6 pt-2">
          <p className="fs-14">SmartDrive was founded with the pioneering spirit to transform<br></br> and ensure safety to fleets and drivers through intelligent<br></br> transport and video-based safety programs. Since then our top<br></br> priority has been to ensure the safety and satisfaction of our<br></br> customers. Harness the potential of resources to innovate and<br></br> evolve a solution that would improve fleets' performance and<br></br> ensure all-rounded safety to the drivers. A solution that was<br></br> resilient, something that would not outgrow the customer’s<br></br> investment.</p>
        </div>
        <div className="col-md-6">
          <div className="text-right">
            <img src={safeSmart1} alt="Safe Smart" className="safe-smart-img" />
          </div>
        </div>        
      </div>      
      <div className="statistics text-secondary">
        <div className="row centered">
          <div className="col-md-3 safe-smart-record">
            <span className="fs-60">100%</span><br></br>
            <span className="font-weight-bold">YOY Subsciption <br></br>Growth</span>
          </div>
          <div className="col-md-3 safe-smart-record">
            <span className="fs-60">148</span><br></br>
            <span className="font-weight-bold">Issued & Pending<br></br>Patents</span>
          </div>
          <div className="col-md-3 safe-smart-record">
            <span className="fs-60">60%</span><br></br>
            <span className="font-weight-bold">Average Safety Score <br></br>Improvement</span>
          </div>
          <div className="col-md-3 safe-smart-record">
            <span className="fs-60">$ 4,900</span><br></br>
            <span className="font-weight-bold">Average Yearly Savings <br></br>per Vehicle Growth</span>
          </div>
        </div>
      </div>
      <div className="row team-smart-drive">
        <div className="col-md-6">
          <div className="team-smart-img1-wrapper">
            <img src={safeSmart2} alt="Safe Smart" className="safe-smart-img2" />
          </div>
        </div>
        <div className="col-md-6">
          <p className="text-gray fs-14 text">With passion and perseverance, we have managed to save lives in<br></br> the shortest time. SmartDrive can excavate into facts efficiently,<br></br> that were otherwise inaccessible. Our coherent intel system has<br></br> helped our customers save money, unnecessary and<br></br> unprecedented expenses. At SmartDrive everything is driven by<br></br> efficiency, our videos are delivered in minutes, giving us an<br></br> unparalleled edge over others, if there are any.</p>
          <p className="text-gray fs-14 text">Above all, we safeguard, watch over fleets and drivers by helping<br></br> reduce potential collisions and personalized guidance. </p>
          <p className="font-weight-bold fs-14 text">Team Smart Drive</p>
          <div className="text-right">
            <img src={safeSmart3} alt="Safe Smart" className="safe-smart-img3" />
          </div>
        </div>
      </div>
    </div>
   );
}
 
export default OurPromise;